<template>
  <!-- eslint-disable vue/no-bare-strings-in-template -->
  <main class="facilitator status">
    <Status :session="session" :links="links" />

    <a v-if="isNotFirstRound" class="button beamer" :href="links.beamer" target="_blank" rel="noopener noreferrer">
      beamer 📽️
    </a>
  </main>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import GameLayout from '/@front:layouts/game.vue'
import type { GameSession } from '/@front:types/shared'

import Status from './status/Status.vue'

defineOptions({
  layout: [GameLayout],
})

const props = defineProps<{
  session: GameSession
  links: Record<string, string>
}>()

const isNotFirstRound = computed(() => props.session.currentRound?.id > 1)
</script>

<style src="/@front:css/views/facilitator.css"></style>
